var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l(([0,1]),function(i){return _c('div',{key:i,staticClass:"is-flex-space-between mb-4"},[_c('span',{staticClass:"loading-info"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }